/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import { ReactKeycloakProvider, useKeycloak } from '@react-keycloak/web';
import Keycloak, { KeycloakInitOptions } from 'keycloak-js';
import { IKeycloakInstance } from './models/IKeycloakInstance';
import { IMaasKeycloak } from './models/IKeycloakProvider';

type TUseKeyCloak = () => { initialized: boolean; keycloak: IKeycloakInstance };

const MaasKeycloak = ({ children, initConfig, config, LoadingComponent, authClient }: IMaasKeycloak) => {
    const keycloakConfig = {
        url: config?.url || process.env.REACT_APP_KEYCLOAK_URL || '',
        realm: config?.realm || process.env.REACT_APP_KEYCLOAK_REALM || '',
        clientId: config?.clientId || process.env.REACT_APP_KEYCLOAK_CLIENT_ID || '',
    };

    if (!authClient) {
        if (!keycloakConfig.url) throw Error('url is required');
        if (!keycloakConfig.realm) throw Error('realm is required');
        if (!keycloakConfig.clientId) throw Error('clientId is required');
    }

    const keycloak = authClient || Keycloak(keycloakConfig);

    const INIT_CONFIG: KeycloakInitOptions = {
        ...initConfig,
        checkLoginIframe: initConfig?.checkLoginIframe || false,
        onLoad: initConfig?.onLoad || 'login-required',
    };

    return (
        <ReactKeycloakProvider LoadingComponent={LoadingComponent} authClient={keycloak} initOptions={INIT_CONFIG}>
            {children}
        </ReactKeycloakProvider>
    );
};

const useMaasKeycloak: TUseKeyCloak = useKeycloak;

export { useMaasKeycloak };
export type { TUseKeyCloak, IMaasKeycloak };
export default MaasKeycloak;
